import { ColDef } from 'ag-grid-community';

import AgGridStatus, { AgGridStatusParams }
  from '@/components/common/TableGrid/CustomComponents/AgGridStatus/AgGridStatus';
import { FILE_STATUS_COLORS } from '@/config/statuses.config';
import AgGridMultilineText
  from '@/components/common/TableGrid/CustomComponents/AgGridMultilineText/AgGridMultilineText';
import AgGridDateFormatter
  from '@/components/common/TableGrid/CustomFormatters/AgGridDateFormatter/AgGridDateFormatter';
import ActionButtons from './ActionButtons';

export function useColumns(): ColDef[] {
  return [
    {
      colId: 'fileName',
      field: 'fileName',
      headerName: 'File Name',
    },
    {
      colId: 'created',
      field: 'created',
      headerName: 'File Upload Date',
      initialWidth: 160,
      minWidth: 160,
      maxWidth: 160,
      cellClass: 'text-center',
      valueFormatter: AgGridDateFormatter
    },
    {
      colId: 'status',
      field: 'status',
      headerName: 'Status',
      cellClass: 'text-center',
      initialWidth: 150,
      minWidth: 150,
      maxWidth: 150,
      cellRenderer: AgGridStatus,
      cellRendererParams: {
        statusColorSchema: FILE_STATUS_COLORS,
      } as AgGridStatusParams,
    },
    {
      colId: 'statusMessage',
      field: 'statusMessage',
      headerName: 'Message',
      wrapText: true,
      autoHeight: true,
      cellRenderer: AgGridMultilineText,
    },
    {
      colId: 'uploadedBy',
      field: 'uploadedByUserName',
      headerName: 'Uploaded By',
      wrapText: true,
      autoHeight: true,
    },
    {
      colId: 'action-buttons',
      field: 'action-button',
      headerName: 'Actions',
      cellRenderer: ActionButtons,
      width: 560,
      minWidth: 520,
      suppressSizeToFit: true,
      cellClass: 'p-0',
      suppressNavigable: true,
    }
  ];
}
